import React, { useState, useEffect } from 'react';
import {
    Box,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Button,
    IconButton,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import EditIcon from '@mui/icons-material/Edit';
import PaginationComponent from '../Pagination';
import { getUsers } from '../../api';

const UserList = () => {
    const navigate = useNavigate();
    const [users, setUsers] = useState([]);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);

    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const response = await getUsers({ page });
                setUsers(response.data.data);
                setTotalPages(response.data.totalPages);
            } catch (error) {
                console.error('Error fetching users:', error);
            }
        };
        fetchUsers();
    }, [page]);

    return (
        <Box p={3}>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                <Typography variant="h5">User List</Typography>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => navigate('/add-user')}
                >
                    Add User
                </Button>
            </Box>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Username</TableCell>
                        <TableCell>Email</TableCell>
                        <TableCell>First Name</TableCell>
                        <TableCell>Last Name</TableCell>
                        <TableCell>Phone</TableCell>
                        <TableCell>Address</TableCell>
                        <TableCell>Status</TableCell>
                        <TableCell>Roles</TableCell>
                        <TableCell>Organization</TableCell>
                        <TableCell>Actions</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {users.map((user) => (
                        <TableRow key={user._id}>
                            <TableCell>{user.username}</TableCell>
                            <TableCell>{user.email}</TableCell>
                            <TableCell>{user.firstName || 'N/A'}</TableCell>
                            <TableCell>{user.lastName || 'N/A'}</TableCell>
                            <TableCell>{user.phone || 'N/A'}</TableCell>
                            <TableCell>
                                {user.address && user.address.street
                                    ? `${user.address.street}, ${user.address.city}, ${user.address.state}, ${user.address.zip}, ${user.address.country}`
                                    : 'N/A'}
                            </TableCell>
                            <TableCell>{user.status}</TableCell>
                            <TableCell>
                                {user.roles.length > 0
                                    ? user.roles.map((role) => role.name).join(', ')
                                    : 'No roles'}
                            </TableCell>
                            <TableCell>{user.organization?.name || 'N/A'}</TableCell>
                            <TableCell>
                                <IconButton
                                    color="primary"
                                    onClick={() => navigate(`/edit-user/${user._id}`)}
                                >
                                    <EditIcon />
                                </IconButton>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
            <PaginationComponent page={page} count={totalPages} onPageChange={setPage} />
        </Box>
    );
};

export default UserList;
